// local
// export const API_URL = "https://public.test/api";
// export const OCCUPANTS_URL = "https://localhost:3001";
// export const ADMIN_URL = "https://localhost:3000";
// export const COBEE_VERSION = "7.0.0";

// test
export const API_URL = "https://api.test.cobee.nl/api";
export const OCCUPANTS_URL = "https://bewoners.test.cobee.nl";
export const ADMIN_URL = "https://beheer.test.cobee.nl";
export const COBEE_VERSION = "7.0.0";

// staging
// export const API_URL = "https://api.staging.cobee.nl/api";
// export const OCCUPANTS_URL = "https://bewoners.staging.cobee.nl";
// export const ADMIN_URL = "https://beheer.staging.cobee.nl";
// export const COBEE_VERSION = "7.0.0";

// production
// export const API_URL = "https://api.cobee.nl/api";
// export const OCCUPANTS_URL = "https://bewoners.cobee.nl";
// export const ADMIN_URL = "https://beheer.cobee.nl";
// export const COBEE_VERSION = "7.0.0";